import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../config/api';
import { TimeZoneSelect } from '../JobFieldInputs';
import { zoneLabel } from '../org/AddressSearch';
import { btnPrimary, InlineError, labelCls, input } from '../ui/Kit';

// Part E: your time zone follows your work location (office, or your home city when remote) until you change it here
export function TimeZoneCard({ user, onSaved }) {
  const [edit, setEdit] = useState(false);
  const [zone, setZone] = useState(user.timezone || '');
  const [error, setError] = useState('');
  const save = async () => {
    setError('');
    try {
      const res = await fetch(API_ENDPOINTS.USERS_UPDATE(user.id), { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ timezone: zone }) });
      if (!res.ok) throw new Error('Could not save your time zone');
      setEdit(false); onSaved && onSaved({ timezone: zone, timezone_source: 'manual', timezone_origin: 'Set by you' });
    } catch (e) { setError(e.message); }
  };
  return (
    <div data-testid="timezone-card">
      <p className="text-sm text-gray-900" data-testid="timezone-line">{zoneLabel(user.timezone) || 'Not set'}</p>
      <p className="text-xs text-gray-500 mt-0.5" data-testid="timezone-origin">{user.timezone_origin || 'Set by you'}</p>
      {edit ? (
        <div className="mt-3 flex flex-wrap items-end gap-3">
          <label className="block"><span className={labelCls}>Time zone</span><TimeZoneSelect className={input} value={zone} onChange={setZone} allowEmpty={false} /></label>
          <button type="button" className={btnPrimary} onClick={save} disabled={!zone} data-testid="timezone-save">Save</button>
        </div>
      ) : <button type="button" className="mt-2 text-sm font-semibold text-[#0066CC] hover:underline" onClick={() => setEdit(true)} data-testid="timezone-change">Change</button>}
      <InlineError>{error}</InlineError>
    </div>
  );
}
